<template>
  <AppPageContainer :showNav="true" :clean="true" :background="'calendar'">
    <div class="day">
        <div>just what i want to do today</div>
    </div>
  </AppPageContainer>
</template>

<script>
import AppPageContainer from "@/components/AppPageContainer";

export default {
  components: {
    AppPageContainer,
  },
  data: function () {
    return {
      temporaryNote: "",
      containers: [],
    };
  },
};
</script>

<style>
.day {
  height: 100%;
  width: 100%;
  position: relative;
  box-sizing: border-box;
}
</style>
